import React, { memo } from 'react';
import Skeleton from './Skeleton';

const ChatSkeleton = memo(function ChatSkeleton({ style = {} }) {
  return (
    <div
      aria-busy="true"
      style={{
        display: 'flex',
        height: 'calc(100vh - 100px)',
        background: '#FFFFFF',
        borderRadius: 14,
        border: '1.5px solid var(--border, #E5E7EB)',
        overflow: 'hidden',
        ...style,
      }}
    >
      {/* Sidebar / Conversation List */}
      <div
        style={{
          width: 320,
          borderRight: '1.5px solid var(--border, #E5E7EB)',
          padding: 16,
          display: 'flex',
          flexDirection: 'column',
          gap: 14,
        }}
      >
        <Skeleton variant="rectangular" width="100%" height={36} borderRadius={8} style={{ marginBottom: 6 }} />
        {Array.from({ length: 5 }).map((_, idx) => (
          <div key={idx} style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <Skeleton variant="circular" width={44} height={44} />
            <div style={{ flex: 1 }}>
              <Skeleton variant="text" width={110} height={14} style={{ marginBottom: 4 }} />
              <Skeleton variant="text" width={150} height={12} />
            </div>
          </div>
        ))}
      </div>

      {/* Active Chat Area */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Chat Header */}
        <div
          style={{
            padding: '16px 20px',
            borderBottom: '1.5px solid var(--border, #E5E7EB)',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
          }}
        >
          <Skeleton variant="circular" width={40} height={40} />
          <div>
            <Skeleton variant="text" width={140} height={16} style={{ marginBottom: 4 }} />
            <Skeleton variant="text" width={90} height={12} />
          </div>
        </div>

        {/* Message Bubbles Thread */}
        <div style={{ flex: 1, padding: 20, display: 'flex', flexDirection: 'column', gap: 16, overflowY: 'auto' }}>
          {/* Left Bubble */}
          <div style={{ display: 'flex', gap: 10, alignSelf: 'flex-start', maxWidth: '60%' }}>
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton variant="rectangular" width={220} height={48} borderRadius={14} />
          </div>

          {/* Right Bubble */}
          <div style={{ alignSelf: 'flex-end', maxWidth: '60%' }}>
            <Skeleton variant="rectangular" width={260} height={60} borderRadius={14} />
          </div>

          {/* Left Bubble */}
          <div style={{ display: 'flex', gap: 10, alignSelf: 'flex-start', maxWidth: '60%' }}>
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton variant="rectangular" width={180} height={42} borderRadius={14} />
          </div>

          {/* Right Bubble */}
          <div style={{ alignSelf: 'flex-end', maxWidth: '60%' }}>
            <Skeleton variant="rectangular" width={150} height={38} borderRadius={14} />
          </div>
        </div>

        {/* Message Input Footer */}
        <div style={{ padding: 16, borderTop: '1.5px solid var(--border, #E5E7EB)', display: 'flex', gap: 12 }}>
          <Skeleton variant="rectangular" width="100%" height={42} borderRadius={9} />
          <Skeleton variant="rectangular" width={48} height={42} borderRadius={9} />
        </div>
      </div>
    </div>
  );
});

export default ChatSkeleton;
